export const oxxioProgressIndicatorTokensColors = {
  progressIndicatorItemDefault: '{{ neutralColors.neutral400 }}',
  progressIndicatorItemDisabled: '{{ neutralColors.neutral200 }}',
  progressIndicatorItemActive: '{{ brandColors.brandDarkBlue }}',
  progressIndicatorItemBorderColor: '{{ linkColors.linkBrand }}',
};
